module.exports = __webpack_public_path__ + "static/img/img-features-feature-2-game-2@3x.45b35d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-2-game-2@3x.png
// module id = jeYA
// module chunks = 18